// 3rd-party modules
import Chart from "react-apexcharts";

// project modules
// import Popup from "../popup/popup";

type Props = {
  options: any;
  series: any[];
  type?:
  | "line"
  | "area"
  | "bar"
  | "pie"
  | "donut"
  | "radialBar"
  | "scatter"
  | "bubble"
  | "heatmap"
  | "candlestick"
  | "boxPlot"
  | "radar"
  | "polarArea"
  | "rangeBar"
  | "rangeArea"
  | "treemap";
  title?: string;
  open: boolean;
  adaptive?: boolean;
  childrenComponent?: any;
  height?: string;
  onClose?: () => void;
};

const CustomChartModal: React.FC<Props> = ({ options, series, type, title,  open, adaptive = false, childrenComponent, height = "95%", onClose }: Props) => {
  return (
    <>
      {/* <Popup
        adaptive={adaptive || undefined}
        title={title}
        onClose={onClose}
        fixSize="large"
        open={open}
        noCommandbar={true}>
        <Chart
          options={options}
          series={series}
          type={type}
          width="100%"
          height={height}
        />
        {!!childrenComponent &&
        <>
          {childrenComponent}
        </>}
      </Popup> */}
    </>
  );
};

export default CustomChartModal;
